import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/ai-prompt-builder/redux/actions';
import FormFieldWithLabel from '../common/FormFieldWithLabel';
import ParentContentCard from '../common/ParentContentCard';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { toast } from 'react-toastify';
import cookie from 'react-cookies';
import * as plugin from '../../features/plugin/redux/actions';
import CustomLoader from '../common/CustomLoader';
import { getUniqueRolesByName } from './utils';
import DropImageZone from './DropImageZone';

export class ImageToLayouts extends Component {
  static propTypes = {
    aiPromptBuilder: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    plugin: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  };

  state = {
    loading: false,
    systemRoles: [],
    imageFile: null,
  };

  handleImageChangeFromDropzone = (file) => {
    const allowedTypes = ['image/jpeg', 'image/png'];
    if (!allowedTypes.includes(file.type)) {
      toast.error('Only JPG, JPEG, and PNG files are supported.');
      this.setState({ imageFile: null });
      return;
    }
    this.setState({ imageFile: file });
  };

  handleGenerateLayout = async (_, { setSubmitting }) => {
    const { match, history, plugin, location, actions } = this.props;
    const { projectId, version } = match.params;
    const { state = {} } = location;
    const { userPrompt, roles } = state;
    const token = cookie.load('token');
    const userIp = cookie.load('userIp');
    const loadSystemRoles = await plugin.loadRoles({ projectId, version });
    const { data } = loadSystemRoles;
    let allRoles = [];
    if (data) {
      allRoles = data.content || [];
    }
    const uniqueSystemRoles = getUniqueRolesByName(allRoles);
    this.setState({ systemRoles: uniqueSystemRoles });
    const { imageFile, systemRoles } = this.state;
    if (!imageFile) {
      toast.error('Please upload an image first.');
      return;
    }

    this.setState({ loading: true });

    try {
      const formData = new FormData();
      formData.append('image', imageFile);
      formData.append('aiModel', process.env.REACT_APP_AI_MODEL);
      formData.append('apiKey', process.env.REACT_APP_API_KEY);
      formData.append('projectId', projectId);
      formData.append('projectVersion', version);
      formData.append('token', token);
      formData.append('userIp', userIp);
      formData.append('systemRoles', JSON.stringify(systemRoles));
      await actions.generateImageLayouts(formData);
      toast.success('Layout generated successfully');
      history.push({
        pathname: `/2.0/ai-prompt-builder/${version}/v/${projectId}/prompt-pages-list`,
        state: { userPrompt, roles: roles },
      });
    } catch (error) {
      console.error('error', error.message);
      toast.error('Something went wrong while generating the layout.');
    } finally {
      setSubmitting(false);
      this.setState({ loading: false });
    }
  };

  render() {
    if (this.state.loading) {
      return (
        <CommonPageComponent>
          <div
            className="row justify-content-center align-items-center"
            style={{ minHeight: '60vh' }}
          >
            <div className="col-12 text-center">
              <ParentContentCard title={'Image To  Layouts'} icon={'link'}>
                <div className="justify-content-center align-items-center py-5">
                  <div>
                    <CustomLoader loading={true} size="20px" color="#303453" />
                  </div>
                  <div className="text-center">
                    <p className="mt-3 font-weight-bold text-center">
                      Please wait while we are generating Layout for your application...
                    </p>
                  </div>
                </div>
              </ParentContentCard>
            </div>
          </div>
        </CommonPageComponent>
      );
    }
    const { loading } = this.state;

    return (
      <CommonPageComponent>
        <ParentContentCard title="Image to Layout" icon="image">
          <div className="container-fluid">
            <Formik initialValues={{ image: null }} onSubmit={this.handleGenerateLayout}>
              {({ isSubmitting, setFieldValue, values }) => (
                <Form className="form-horizontal">
                  <DropImageZone
                    onFileSelect={(file) => {
                      this.handleImageChangeFromDropzone(file);
                      setFieldValue('image', file);
                    }}
                    selectedImage={this.state.imageFile}
                  />
                  <div className="text-right mt-3">
                    <button
                      type="submit"
                      className={`btn ${values.image ? 'btn-theme-submit' : 'btn-disabled'} btn-md`}
                      disabled={!values.image || loading || isSubmitting}
                    >
                      <i className="wb webconnect-rocket"></i> &nbsp;Generate Layout
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </ParentContentCard>
      </CommonPageComponent>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    aiPromptBuilder: state.aiPromptBuilder,
    plugin: state.plugin,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    plugin: bindActionCreators({ ...plugin }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ImageToLayouts);
